import { Html } from '@react-three/drei';
import { EmptyState, MantineOverrideProvider } from '@uag/react-core';
import { useTranslation } from 'react-i18next';

import 'app/modules/wallforming/custom-styles/customEmptyStateStyle.css';

export const ArticlePreviewPlaceholder = () => {
    const { t } = useTranslation();

    return (
        <Html zIndexRange={[0, 0]} fullscreen>
            <MantineOverrideProvider>
                <div className="flex items-center justify-center h-full w-full bg-none">
                    <EmptyState icon="info" title={t('placeholderArticlePreview')} variant="compact" />
                </div>
            </MantineOverrideProvider>
        </Html>
    );
};
